import { sharePointHelpers } from "@qdabra/forms-shared/sharePoint";

import valueHandler from "./sharePointList.valueHandler.rest";
import query from "./list.rest.query";

const { getDomainFromUrl } = sharePointHelpers;

const restImplementation = (siteUrl) => ({
    query,
    getValue: valueHandler(getDomainFromUrl(siteUrl)),
});


export default restImplementation;